import Marquee from "react-fast-marquee";

const WORDS = ["HANDY'S", "REMONTY", "WYKOŃCZENIA", "ELEKTRYKA", "HYDRAULIKA", "PŁYTKI", "MONTAŻ", "NAPRAWY", "WYVÓZ GRUZU", "SPRZĄTANIE"];

export default function EditorialMarquee() {
    return (
        <section className="overflow-hidden border-y border-white/10 bg-ink py-10 md:py-14" aria-hidden>
            <Marquee speed={28} gradient={false} pauseOnHover={false}>
                {WORDS.map((w, i) => (
                    <span key={i} className="flex items-center">
                        <span
                            className={`whitespace-nowrap px-8 font-display text-5xl font-black uppercase tracking-tight md:text-7xl ${
                                i % 2 === 0 ? "text-white" : "text-outline"
                            }`}
                        >
                            {w}
                        </span>
                        <span className="h-3 w-3 rotate-45 bg-gold" />
                    </span>
                ))}
            </Marquee>
        </section>
    );
}
